import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { deliveryMenus } from "./menus";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Back",
	updateManyExternalIntegrations: {
		success: "Integrations updated successfully",
	},
	externalStoreIntegrationStatus: {
		synced: "Synced",
		pendingSyncing: "Syncing pending",
		pendingImporting: "Importing pending",
	},
	ordersManager: {
		title: "Orders Manager",
		description:
			"Track and manage orders that come from Entregue já, Comanda Online and Pedido na mesa.",
		filter: {
			placeholder: "Filter by",
		},
		tabs: {
			newOrders: "New Orders",
			inDelivery: "In Delivery",
			completed: "Completed",
		},
		createOrder: "Create new order",
		loading: "Loading",
		total: "Total: {{value}}",
		new: "New",
		emptyState: {
			title: "We don't have any {{status}} orders yet.",
			description: "We'll show you here when you receive new orders.",
		},
		immersion: {
			enter: "Immersion",
			exit: "Exit immersion",
		},
		sound: {
			on: "Sound on",
			off: "Sound off",
		},
		whatsNew: {
			intro: {
				title: "We have news here! 🎉",
				description:
					"We've updated the Orders manager. Want a quick look at what changed?",
				start: "See what's new",
			},
			step: "Step {{current}} of {{total}}",
			next: "Next",
			finish: "Got it",
			skip: "Skip",
			test: "Play sample sound",
			immersion: {
				title: "New: Immersion mode",
				description:
					"Put the manager in full screen, without menus — ideal for counter use.",
			},
			sound: {
				title: "New: New order sound",
				description:
					"We play a sound alert when a new order arrives. Use the button to enable or mute it.",
			},
		},
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
